import { CSSProperties, FC, ReactNode } from 'react'
import ExerciseMock from '@images/ExerciseMock.png' // Убедитесь, что путь к маске верный
import SkeletonCard from 'react-loading-skeleton' // Переименовал, чтобы не конфликтовать с названием компонента.

interface Props {
	bgImage?: string
	bgColor?: string
	children?: ReactNode
	styles?: CSSProperties
	isSkeleton?: boolean // Новый необязательный пропс для скелетона
}

export const RoundedBackground: FC<Props> = ({
	bgImage,
	children,
	styles,
	bgColor,
	isSkeleton,
}) => {
	// Расчеты размеров остаются прежними, но только если это не скелетон без bgImage
	const containerWidth = typeof window !== 'undefined' ? Math.min(window.innerWidth, 500) : 500
	const maskAspectRatio = 385 / 288
	const maskHeight = bgImage || isSkeleton ? containerWidth / maskAspectRatio : 286

	return (
		<div
			style={{
				position: 'relative',
				width: '100%',
				maxWidth: '500px',
				height: maskHeight, // Высота теперь зависит от bgImage или isSkeleton
				margin: '0 auto',
				...styles,
			}}>
			<div
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%', // Теперь высота всегда 100% от родителя
					background: bgColor && !isSkeleton ? bgColor : '', // Фон только если не скелетон
					backgroundImage: bgImage && !isSkeleton ? `url(${bgImage})` : 'auto', // Изображение только если не скелетон
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					maskImage: `url(${ExerciseMock})`, // Маска всегда применяется
					maskSize: '100% 100%',
					maskRepeat: 'no-repeat',
					maskPosition: 'center',
					overflow: 'hidden', // Чтобы скелетон не вылезал за маску
				}}>
				{isSkeleton ? (
					<SkeletonCard
						style={{
							width: '100%',
							height: '100%',
							borderRadius: 0,
						}}
					/>
				) : (
					// Иначе показываем обычный дочерний контент
					children
				)}
			</div>
		</div>
	)
}
